import partnerService from '../service/partner'

const state = {
    loading: false,
}

const actions = {
    updatePreferences({ commit }, preferences) {
        commit('setLoading', true)
        return partnerService.updatePreferences(preferences).then(() => {
            commit('setLoading', false)
        })
    },
};
const mutations = {
    setLoading(state, loading) {
        state.loading = loading
    },
};
export default {
    namespaced: true,
    state,
    actions,
    mutations
};
